import React from "react";
// import RcSteps from '../../_rc-steps-3.0.1';
import Loadable from "../../react-loadable";
const RcSteps = Loadable({
  loader: () => import("../../_rc-steps-3.0.1"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
const Step = Loadable({
  loader: () => import("../../_rc-steps-3.0.1/src/Step"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});
export default class Steps extends React.Component {
  // static Step = RcSteps.Step;
  static Step = Step;

  static defaultProps = {
    prefixCls: "ant-steps",
    iconPrefix: "ant",
    current: 0
  };

  render() {
    return <RcSteps {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./_antd1.11.2/steps/index.jsx